<div class="mam-toolbar">
  <div class="mam-toolbar__actions">
    <button class="mam-toolbar__btn mam-toolbar__btn--primary" (click)="uploadClick.emit()">
      Upload
    </button>
    <button class="mam-toolbar__btn" (click)="exportClick.emit()">
      Export
    </button>
  </div>

  <div class="mam-toolbar__filters">
    <input
      class="mam-toolbar__search"
      type="text"
      placeholder="Search by title…"
      [value]="localSearch"
      (input)="onSearchInput($any($event.target).value)"
      (keypress)="onSearchKeypress($event)"
    />

    <select
      class="mam-toolbar__select"
      [value]="statusFilter"
      (change)="onStatusChange($any($event.target).value)"
    >
      @for (opt of statusOptions; track opt.value) {
        <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  </div>
</div>
